import React, { useEffect, useRef, useState } from "react";
import { PiMagnifyingGlassMinus, PiMagnifyingGlassPlus } from "react-icons/pi";
import { AppLayout } from "../../../layouts";
import { Buttton, Header, Sides } from "../../../components";
import { Col, Container, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { actionCommon, actionDoctor } from "../../../redux/actions";
import { useTranslation } from "react-i18next";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { useAlert, useToast } from "../../../contexts";

const PdfPreview = ({ loginData }) => {
    const { t } = useTranslation();
    const { showToast } = useToast();
    const { showAlert } = useAlert();
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const invoiceDetails = location.state?.invoiceDetails;
    const invoiceDetails1 = location.state?.invoiceDetails1;
    const appointment = location.state?.appointment;
    const [zoomLevel, setZoomLevel] = useState(1);
    const invoiceRef = useRef();

    const handleZoomIn = () => setZoomLevel((prev) => Math.min(prev + 0.1, 2));
    const handleZoomOut = () => setZoomLevel((prev) => Math.max(prev - 0.1, 0.5));

    const additionalServicesTotal = invoiceDetails?.additionalService?.servicesModel?.reduce(
        (acc, item) => acc + (Number(item.totalAmount) || 0),
        0
    );

    const subtotal = Number(invoiceDetails?.TotalAmount || 0) + additionalServicesTotal;
    const discountAmount = (subtotal * Number(invoiceDetails1?.discount || 0)) / 100;
    const finalTotal = subtotal - discountAmount;

    const generatePdf = async () => {
        const input = invoiceRef.current;
        if (!input) return;

        const canvas = await html2canvas(input, {
            scale: 1,
            useCORS: true,
        });

        const imgData = canvas.toDataURL("image/jpeg", 0.7);
        const pdf = new jsPDF("p", "mm", "a4");

        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);

        const invoiceNumber = invoiceDetails.invoiceNumber?.split("/")?.[0] || "preview";
        const fileName = `${invoiceNumber}.pdf`;

        const pdfBlob = pdf.output("blob");
        const formData = new FormData();
        formData.append("PdfContent", pdfBlob);
        formData.append("FileName", fileName);
        formData.append("appointmentGuid", appointment?.appointmentGuid);
        pdf.save(fileName);

        dispatch(
            actionCommon.uploadPdf(formData, (error, response) => {

                if (error) {
                    if (error.data) {
                        if (error.data.statusCode === 400) {
                            if (error.data.error && error.data.error.ValidationErrors) {
                                error.data.error.ValidationErrors.forEach((validationError) => {
                                    console.error(
                                        `${t("Field")}: ${validationError.Field} - ${t(
                                            "Message"
                                        )}: ${validationError.Message}`
                                    );

                                    showAlert(
                                        "danger",
                                        validationError.Message,
                                        `${t("Error")} : ${validationError.Field}`
                                    );
                                });
                            } else {
                                showAlert(
                                    "danger",
                                    t("Invalid_credentials"),
                                    `${t("Error")} !`
                                );
                            }
                        } else {
                            showAlert("danger", t("unexpected_error"), `${t("Error")} !`);
                        }
                    }
                } else if (response) {
                    if (response.status === 200) {
                        dispatch(
                            actionDoctor.postUpdatePdf({
                                appointmentGuid: appointment?.appointmentGuid,
                                pdfUrl: response?.data?.result?.data?.url
                            }, (error, response) => {

                                if (error) {
                                    if (error.data) {
                                        if (error.data.statusCode === 400) {
                                            if (error.data.error && error.data.error.ValidationErrors) {
                                                error.data.error.ValidationErrors.forEach((validationError) => {
                                                    console.error(
                                                        `${t("Field")}: ${validationError.Field} - ${t(
                                                            "Message"
                                                        )}: ${validationError.Message}`
                                                    );

                                                    showAlert(
                                                        "danger",
                                                        validationError.Message,
                                                        `${t("Error")} : ${validationError.Field}`
                                                    );
                                                });
                                            } else {
                                                showAlert(
                                                    "danger",
                                                    t("Invalid_credentials"),
                                                    `${t("Error")} !`
                                                );
                                            }
                                        } else {
                                            showAlert("danger", t("unexpected_error"), `${t("Error")} !`);
                                        }
                                    }
                                } else if (response) {
                                    if (response.status === 200) {

                                        showToast(
                                            t("success"),
                                            t("pdf_uploaded_successfully"),
                                            5000,
                                            true,
                                            "top-end toast-success"
                                        );
                                    }
                                }
                            })
                        );
                    }
                }
            })
        );
    };




    useEffect(() => {
        if (location.state?.generate) {
            generatePdf();
        }
    }, [location.state]);


    const buttons = (
        <>
            <Buttton.Buttton
                children={t("CANCEL")}
                className="btn-border-Aqua_Teal"
                onClick={() => navigate(-1)}
            />
            <Buttton.Buttton
                children={`${t("print")} & ${t("save")}`}
                className="btn-solid-Aqua_Teal"
                onClick={generatePdf}
            />
        </>
    );

    const rightSide = (
        <Container fluid className="exado-container1">
            <Row className="exado-row1">
                <Col>
                    <Header.HeadingPage
                        pageHeading={t("pdf_preview.invoice_pdf_view")}
                        buttons={buttons}
                    />
                </Col>
            </Row>
            <Row className="exado-row1 pdf-exado-row">
                <div className="pdf-zoom-btn-blk">
                    <span className="zoom-btn" onClick={handleZoomIn}>
                        <PiMagnifyingGlassPlus />
                    </span>
                    <span className="zoom-btn zoom-btn-two" onClick={handleZoomOut}>
                        <PiMagnifyingGlassMinus />
                    </span>
                </div>
                <Col className="d-flex justify-content-center align-items-center">
                    <div
                        ref={invoiceRef}
                        style={{ transform: `scale(${zoomLevel})`, transition: "0.3s ease" }}
                        className="invoice-page"
                    >
                        <section className="invoice-section">
                            <h6 className="invoice-section-head exado_body_text_one">
                                {t("pdf_preview.invoice_nr")}. {invoiceDetails.invoiceNumber}
                            </h6>
                            <ul className="invoice-section-ul">
                                <li className="invoice-section-li">
                                    {t("date")} : {new Date(invoiceDetails.invoiceDate).toLocaleDateString("en-GB").replace(/\//g, ".")}
                                </li>
                                <li className="invoice-section-li">
                                    {t("Diagnosis")} : {invoiceDetails.diagnosticConclusion}
                                </li>
                                <li className="invoice-section-li">
                                    {t("booking_id")} : {invoiceDetails.bookingId}
                                </li>
                            </ul>
                        </section>
                        <section className="invoice-section-two">
                            <div className="is-details-blk">
                                <h6 className="invoice-section-head exado_body_text_one">
                                    {t("pdf_preview.invoice_to")}:
                                </h6>
                                <ul className="invoice-section-ul">
                                    <li className="invoice-section-li">
                                        {t("patient_name")} : {invoiceDetails.patientFirstName} {invoiceDetails.patientLastName}
                                    </li>
                                    <li className="invoice-section-li">
                                        {t("Address")} : {invoiceDetails.patientAddress}
                                    </li>
                                    <li className="invoice-section-li">
                                        {t("Post_Code")} : {invoiceDetails.patientPostCode}
                                    </li>
                                    <li className="invoice-section-li">
                                        {t("email")} : abc@gmail.com
                                    </li>
                                    <li className="invoice-section-li">
                                        {t("phone")} : {invoiceDetails.patientPhoneNumber}
                                    </li>
                                </ul>
                            </div>
                            <div className="is-details-blk">
                                <h6 className="invoice-section-head exado_body_text_one">
                                    {t("pay_to")}:
                                </h6>
                                <ul className="invoice-section-ul">
                                    <li className="invoice-section-li">
                                        {t("doctor_name")} : {invoiceDetails.senderFirstName} {invoiceDetails.senderLastName}
                                    </li>
                                    <li className="invoice-section-li">
                                        {t("clinic_name")} : {invoiceDetails.senderClinicsName}
                                    </li>
                                    <li className="invoice-section-li">
                                        {t("Address")} : {invoiceDetails.senderAddress}
                                    </li>
                                    <li className="invoice-section-li">
                                        {t("Post_Code")} : {invoiceDetails.senderPostCode}
                                    </li>
                                    <li className="invoice-section-li">
                                        {t("email")} : {invoiceDetails.senderEmail}
                                    </li>
                                    <li className="invoice-section-li">
                                        {t("phone")} : {invoiceDetails.senderPhoneNumber}
                                    </li>
                                </ul>
                            </div>
                        </section>
                        <p className="invoiced-pra">{t("pdf_preview.invoice_details")}</p>
                        <table className="invoiced-table">
                            <tr className="invoiced-tr">
                                <td className="invoiced-td">{t("Services")}</td>
                                <td className="invoiced-td">QNT</td>
                                <td className="invoiced-td">{t("amount")}</td>
                            </tr>
                            <tr className="invoiced-tr">
                                <td className="invoiced-td">{t("pdf_preview.clinic_consultation")}</td>
                                <td className="invoiced-td">1</td>
                                <td className="invoiced-td">{invoiceDetails.TotalAmount}</td>
                            </tr>
                            {invoiceDetails?.additionalService?.servicesModel?.map((service, index) => (
                                <tr key={index} className="invoiced-tr">
                                    <td className="invoiced-td">{service.serviceName}</td>
                                    <td className="invoiced-td">1</td>
                                    <td className="invoiced-td">{service.totalAmount}</td>
                                </tr>
                            ))}
                        </table>
                        <div className="d-flex align-items-center justify-content-end itotal">
                            <ul className="invoice-section-ul">
                                <li className="invoice-section-li">
                                    <span className="invoice-section-li-span">{t("subtotal")} :</span>
                                </li>
                                <li className="invoice-section-li">
                                    <span className="invoice-section-li-span">
                                        {t("service_discount")} {invoiceDetails1.discount}% :
                                    </span>
                                </li>
                                <li className="invoice-section-li">
                                    <span className="invoice-section-li-span">{t("total")} :</span>
                                </li>
                            </ul>
                            <ul className="invoice-section-ul">
                                <li className="invoice-section-li text-end">
                                    {subtotal.toFixed(2)} {invoiceDetails?.currency}
                                </li>
                                <li className="invoice-section-li text-end">
                                    {discountAmount.toFixed(2)} {invoiceDetails?.currency}
                                </li>
                                <li className="invoice-section-li text-end">
                                    {finalTotal.toFixed(2)} {invoiceDetails?.currency}
                                </li>
                            </ul>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );

    return (
        <AppLayout.AppLayoutOne
            leftSide={<Sides.LeftSides loginData={loginData} />}
            rightSide={rightSide}
        />
    );
};

export default PdfPreview;